<template>
    <div class="title-container">
            <router-link :to="'/' + backVue" v-if="backArrow">
                <img alt="back" src="../assets/back-primary.svg" class="title-img"/>
            </router-link>
            <h1 v-bind:class="{faded:!selected}">{{text}}</h1>
        </div>
</template>

<script>
export default {
  name: "Title",
  props: {
    text: String,
    backArrow: Boolean,
    backVue: String,
    selected: {
      type: Boolean,
      default: true,
    },
  },
  mounted () {
      // console.log(this.selected);
  }
};
</script>

<style scoped>
    .title-container{
        width: 100%;
        text-align: left;
        padding-top: 30px;
        display: inline-flex;
    }

    .title-img{
        width:30px;
        float: left;
        margin-right: 30px;
    }
    .faded {
      color: rgb(180, 180, 180) !important;
      /* background-color: red; */
    }
</style>